<template>
<span v-if="playerMethod">
  <video-player
    :vimeo-file="vimeoFile"
    :film-files="filmFiles"
    :poster="poster"
    :autoplay="autoplay"
    :big="big"
    :film-master="filmMaster"
    :player-method="playerMethod"
    class="fid-player-underlay"
  />
</span>
</template>

<script>
import Plyr from '@/components/Plyr'
import { settings } from '@/js/store'
import { DefinitionFormats, AspectRatios, FrameRates } from '@/gql'
import { SearchUtils } from '@/js'
import { mapState, mapGetters } from 'vuex'
import { vxMaps } from '@/js/vxstore'
export default {
  components: {
    'video-player': Plyr
  },

  computed: {
    poster () {
      const path = this.isFilm &&
        this.activeSlide &&
        this.activeSlide.best &&
        this.activeSlide.best.path

      const image = path || SearchUtils.getImageFromReason({
        reason: this.reason,
        rowType: 'film',
        big: this.big,
        filmMaster: this.filmMaster
      })

      return image
    },
    ff () {
      return this.filmMaster && this.filmMaster.FilmFiles
    },
    areFilmFiles () {
      return (this.filmFiles && this.filmFiles.length)
    },
    vimeoFile () {
      return this.reason && this.reason.VimeoUserVideo
    },
    areVimeoFiles () {
      return this.vimeoFile && this.vimeoFile.files
    },
    playerMethod () {
      if (this.areFilmFiles) return 'fid'
      if (this.vimeoFile) return 'vimeo-embed'
      if (this.youtubeFile) return 'youtube-embed'
      return null
    },
    filmFiles () {
      // patch up the film files
      if(!this.ff) return null
      // 1st find the source file, as it's download link will be used for any downloading
      const sourceFile = this.ff.find(f => f.source)
      // now filter out those with no path an fix the hls mimetype, and add a link to the download for the source file
      // vimeo returns the wrong mimetype,
      // TODO the download thing is currently not enabled - need to figure out how to frsh query to get a non expired download link
      const { hlsMimeType, hlsQuality } = settings.videos
      const filmFiles =  this.ff.filter(f => f.path).map(f => ({
        ...f,
        type: f.distributionFormat === 'hls' ? hlsMimeType : f.mimeType,
        quality: f.distributionFormat === 'hls' ? hlsQuality : f.width,
        download: sourceFile && (sourceFile.FilmFileDownload || sourceFile.path)
      }))
     
      return filmFiles;
    },
    filmMaster () {
      // mock a filmmaster and files - in thid scenario we're playing directly from vimeo
      // and we also have access to the raw film files
      if (this.vimeoFile) {
        // TODO dont think we need the vimeo user do we (maybe for embedding)?
        const vimeoUser = null;
        return SearchUtils.mockFilmMasterFromVimeo({
          vimeoFile: this.vimeoFile,
          vimeoUser,
          aspectRatios: this.AspectRatios,
          frameRates: this.FrameRates,
          definitionFormats: this.DefinitionFormats
        })
      } else {
        return this.master
      }
    },
    ...mapState(vxMaps.state),
    ...mapGetters(vxMaps.getters)
  },

  props: {
    reason: Object,
    autoplay: Boolean,
    big: Boolean,
    master: Object
  },
  data: () => ({
    DefinitionFormats: null,
    AspectRatios: null,
    FrameRates: null
  }),
  apollo: {
    DefinitionFormats: {
      query: DefinitionFormats
    },
    AspectRatios: {
      query: AspectRatios
    },
    FrameRates: {
      query: FrameRates
    }
  }
}
</script>
